import { useState } from "react";
import { Collapse, Button, Card } from "reactstrap";

const OtherWaysToSupport = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <>
      <div className='d-flex'>
        <Button color='primary' onClick={toggle} style={{ marginBottom: "1rem" }}>
          <h5> Other Ways To Donate</h5>
        </Button>
      </div>
      <div>
        <Collapse isOpen={isOpen} className='mb-4'>
          <Card>
            <div className='row p-3'>
              <div className='col-sm-12'>
                <ul>
                  <h5>
                    <li>
                      <a href='https://kpfa.org/donate-your-vehicle/'>Donate Your Vehicle</a>
                    </li>
                    <li>
                      <a href='https://kpfa.org/qcds-dafs/'>
                        Qualified Charitable Distributions (QCD) and Donor-Advised Funds (DAF)
                      </a>
                    </li>
                    <li>
                      <a href='https://kpfa.org/employer-matching/'>Employer Matching</a>
                    </li>
                    <li>
                      <a href='https://kpfa.org/stocks/'>Stock Donations</a>
                    </li>
                    <li>
                      <a href='https://kpfa.org/legacy/'>Wills and Living Trusts</a>
                    </li>
                  </h5>
                </ul>
                <p>
                  If you would like to send us a physical check, please use our PO Box address:
                  <address className='mt-'>
                    <strong>
                      KPFA Radio
                      <br /> PO Box 11408
                      <br /> Berkeley, CA 94712-2408
                    </strong>
                  </address>
                </p>
                <p>
                  For additional help, please contact our Development department at{" "}
                  <a href='mailto:development@kpfa.org?subject=Other ways to donate'>
                    development@kpfa.org
                  </a>
                </p>
              </div>
            </div>
          </Card>
        </Collapse>
      </div>
    </>
  );
};

export default OtherWaysToSupport;
